import { render, staticRenderFns } from "./EmpAdv.vue?vue&type=template&id=2c9c065f&scoped=true&"
import script from "./EmpAdv.vue?vue&type=script&lang=js&"
export * from "./EmpAdv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c065f",
  null
  
)

export default component.exports